import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { InfoblockPersistenceService } from './infoblock-persistence.service';
import { INFOBLOCK_FEATURE } from './infoblock-state';
import { reducerProvider, reducerToken } from './reducers';

export function infoBlockStatePersistenceFactory(infoblockPersistenceService: InfoblockPersistenceService): () => void {
  return () => infoblockPersistenceService.sync();
}

@NgModule({
  imports: [StoreModule.forFeature(INFOBLOCK_FEATURE, reducerToken)],
  providers: [
    reducerProvider,
    provideAppInitializer(() => {
      const initializerFn = infoBlockStatePersistenceFactory(inject(InfoblockPersistenceService));

      return initializerFn();
    }),
  ],
})
export class InfoblockStoreModule {}
